import { FormItem, ISelectInputProps } from '@framework/form';
import React from 'react';
import { SimilInputSpan } from '../../../../../../ui/form/SimilInputSpan';
import { $SpaceCompact } from '../../../../../../ui/form/SpaceCompact';
import { AsyncServiceSelectInput } from '../../../../../expressions/repository/async/input/AsyncServiceSelectInput';

export interface IServiceSelectorInputProps {
  onChange: ISelectInputProps['onChange'];
  name: string;
  label?: string;
}

export function ServiceSelectorInput(props: IServiceSelectorInputProps) {
  const { onChange, name } = props;
  return (
    <FormItem label="" name={name}>
      <$SpaceCompact size="large" block>
        <SimilInputSpan>{props.label ?? 'Servizio'}</SimilInputSpan>

        <AsyncServiceSelectInput
          name={name}
          style={{ width: '100%' }}
          onChange={onChange}
        />
      </$SpaceCompact>
    </FormItem>
  );
}
